import styled from "styled-components";

const RightImageText = styled.div`
  font-size: 20px;
  width: 75%;

  @media (max-width: 1599px) {
    font-size: 15px;
    margin-left: 10px;
  }
  @media (max-width: 1599px) {
    font-size: 12px;
  }
`;
export default RightImageText;
